import type { CustomListItem } from '../types/CustomListSchema';
import type { CatalogItem } from 'entities/CatalogItem/model/types/CatalogItemSchema';

/**
 * Product/catalog fields live on the nested `item` hash (property-catalog shape).
 */
export const getCustomListCatalogItem = (
    listItem: CustomListItem,
): CatalogItem | undefined => listItem.item;

export const getCustomListCatalogItemId = (
    listItem: CustomListItem,
): string | undefined =>
    listItem.catalogItemId ||
    listItem.item?.catalogItemId ||
    listItem.item?.id ||
    undefined;
